export default __webpack_public_path__ + "static/media/react.0e8c9066.jpg";